import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import bonboz from './bonboz.json';
import calls from './calls.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import sessionLimit from './sessionLimit.json';
import yearInReview from './yearInReview.json';
import bonbozGhiDe from './bonboz_ghi_de.json';
import { gopSau } from '../../gopSau';

export default gopSau(
  {
    ...advancedFilters,
    ...agentBots,
    ...agentMgmt,
    ...attributesMgmt,
    ...auditLogs,
    ...automation,
    ...bulkActions,
    ...bonboz,
    ...calls,
    ...campaign,
    ...cannedMgmt,
    ...chatlist,
    ...companies,
    ...components,
    ...contact,
    ...contactFilters,
    ...conversation,
    ...csatMgmt,
    ...customRole,
    ...datePicker,
    ...emoji,
    ...general,
    ...generalSettings,
    ...helpCenter,
    ...inbox,
    ...inboxMgmt,
    ...integrationApps,
    ...integrations,
    ...labelsMgmt,
    ...login,
    ...macros,
    ...report,
    ...resetPassword,
    ...search,
    ...setNewPassword,
    ...settings,
    ...signup,
    ...sla,
    ...snooze,
    ...teamsSettings,
    ...whatsappTemplates,
    ...contentTemplates,
    ...mfa,
    ...onboarding,
    ...sessionLimit,
    ...yearInReview,
  },
  bonbozGhiDe
);
